import { Link } from "react-router-dom";

export default function BasicHeaderDocumentos ({url, title, onClick} : {url: string, title: string, onClick?: ()=>void}){
    return (
        <>
        <div className="header-link">
            <Link to={url} className='back-button w-inline-block' onClick={onClick}/>
            <h3 className='h3-titles xl'>{title}</h3>
        </div>
        <div className="separador" />
        </>
    )
}